module.exports = __webpack_public_path__ + "img/logo.b396140e.png";